@if (shouldShowBanner()) {
  <div class="install-banner" role="banner" aria-label="App install banner">
    <a class="banner-link" [href]="installUrl()" (click)="onInstallClick($event)" aria-label="Open Gains.com app">
      <img class="app-icon" [src]="('cdnUrl' | env) + '/images/ios_gains_icon.webp'" alt="Gains.com App" width="40" height="40" />
      <div class="banner-info">
        <span class="app-name">Gains.com</span>
        <span class="app-subtitle">Get your Gains on the go.</span>
      </div>
      <div class="cta-section">
        <span class="get-button">Open</span>
      </div>
    </a>
    <button type="button" class="close-button" (click)="onDismiss($event)" aria-label="Dismiss install banner">
      <ac-icon iconKey="hr:ios_xmark" [size]="24" />
    </button>
  </div>
}
